import { render } from "./webU.vue?vue&type=template&id=3cbd12b2"
import script from "./webU.vue?vue&type=script&lang=js"
export * from "./webU.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__